import { t } from "i18next";
import * as yup from "yup";

class AdminRequestAccountingUpdate {
    constructor({
        id = "",
        name = "",
        value = "",
        message = "",
        showLabel = "",
        requiredDocumentation = [],
        deleted = false,
    } = {}) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.message = message;
        this.showLabel = showLabel;
        this.requiredDocumentation = requiredDocumentation || [];
        this.deleted = deleted;
    }

    static getAttributes(filter = null, isYupSchema = false) {
        if (isYupSchema) {
            return yup.object().shape({
                id: yup.string(),
                name: yup
                    .string()
                    .required('validationMessage.nameRequired')
                    .min(2, 'validationMessage.nameMinLength'),
                value: yup
                    .string()
                    .required('validationMessage.valueRequired')
                    .matches(/^\d{4}$/, 'validationMessage.valueMustBe4Digits')
                    .test('range', 'validationMessage.valueRange', (value) => {
                        if (!value) return false;
                        const num = parseInt(value, 10);
                        return num >= 1000 && num <= 9999;
                    }),
                message: yup.string(),
                showLabel: yup.string(),
                requiredDocumentation: yup.array().of(yup.string()),
                deleted: yup.boolean(),
            });
        }

        const attributes = {
            id: {
                'label': 'ID',
                'form': false,
                'id': 'id',
                'name': 'id',
            },
            name: {
                'label': t('accounting.name'),
                'form': true,
                'id': 'name',
                'name': 'name',
                'type': 'text',
                'placeholder': t('accounting.namePlaceholder'),
            },
            value: {
                'label': t('accounting.value'),
                'form': true,
                'id': 'value',
                'name': 'value',
                'type': 'text',
                'placeholder': t('accounting.valuePlaceholder'),
            },
            message: {
                'label': t('accounting.message'),
                'form': true,
                'id': 'message',
                'name': 'message',
                'type': 'textarea',
                'placeholder': t('accounting.messagePlaceholder'),
            },
            showLabel: {
                'label': t('accounting.showLabel'),
                'form': false,
                'id': 'showLabel',
                'name': 'showLabel',
            },
            requiredDocumentation: {
                'label': t('accounting.requiredDocumentation'),
                'form': true,
                'id': 'requiredDocumentation',
                'name': 'requiredDocumentation',
                'type': 'checkbox-group',
            },
            deleted: {
                'label': 'Deleted',
                'form': false,
                'id': 'deleted',
                'name': 'deleted',
            },
        };

        if (typeof filter === "string") {
            return { [filter]: attributes[filter] };
        }
        if (Array.isArray(filter)) {
            const filteredAttributes = {};
            filter.forEach(key => {
                filteredAttributes[key] = attributes[key];
            });
            return filteredAttributes;
        }
        return attributes;
    }

    // Available documentation options
    static getDocumentationOptions() {
        return [
            { value: 'Deltagarlista', label: 'Deltagarlista' },
            { value: 'Antal deltagare', label: 'Antal deltagare' },
            { value: 'Program eller kallelse', label: 'Program eller kallelse' },
        ];
    }
}

export default AdminRequestAccountingUpdate;